import { InjectionToken } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CAMPAIGN_IDS_WITH_EXPIRATION_DATE: InjectionToken<number[]> = new InjectionToken<number[]>(
  'campaignIdsWithExpirationDate',
  {
    factory: () => []
  }
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SUPERIOR_IDS_WITH_EXPIRATION_DATE: InjectionToken<number[]> = new InjectionToken<number[]>(
  'superiorIdsWithExpirationDate',
  {
    factory: () => []
  }
);
